import { getResolvedAsyncApiRef as e } from "@scalar/workspace-store/helpers/get-resolved-async-api-ref";
import { isObject as t } from "@scalar/helpers/object/is-object";
import { resolveAsyncApiSchema as n } from "@scalar/workspace-store/helpers/resolve-async-api-schema";
import { snapshotSchema as r } from "@scalar/workspace-store/helpers/snapshot-schema";
import { getExampleFromSchema as i } from "@scalar/workspace-store/request-example";
//#region src/code-example/helpers/get-generated-payload-example.ts
var a = (n, r = /* @__PURE__ */ new Set()) => {
	let i = e(n);
	return i === !1 ? !0 : !t(i) || r.has(i) ? !1 : (r.add(i), Array.isArray(i.allOf) && i.allOf.some((e) => a(e, r)));
}, o = (o) => {
	if (o.examples?.some((t) => e(t)?.payload !== void 0)) return;
	let s = e(o.payload);
	if (typeof s == "boolean" || t(s) && "schemaFormat" in s && typeof e(s.schema) == "boolean") return;
	let c = n(o.payload), l = c?.kind === "schema" ? c.schema : void 0;
	if (!l || a(l)) return;
	let u = r(l);
	return i(u, {
		emptyString: "string",
		includeDeprecated: !0
	});
};
//#endregion
export { o as getGeneratedPayloadExample };

//# sourceMappingURL=get-generated-payload-example.js.map